import { ViewChild, Injector } from '@angular/core';
import { GmapsPoint } from './gmaps-point.model';
import { GmapsDirectionsDirective } from './gmaps-directions.directive';
import { MapsAPILoader } from '@agm/core';
import { BaseComponent } from './../base-components/base-component';
declare var google: any;

export abstract class GmapsHelpers extends BaseComponent {
  @ViewChild(GmapsDirectionsDirective) directionsDirective: GmapsDirectionsDirective;
  public zoom: number = 16;
  private mapsAPILoader: MapsAPILoader;

  constructor(
    injector: Injector
  ) {
    super(injector);
    this.mapsAPILoader = this.injector.get(MapsAPILoader, (this.mapsAPILoader = null));
  }

  public initGmapsDirections(origin: GmapsPoint, destination: GmapsPoint, inputRef?: any): void {
    if (this.directionsDirective) {

      this.directionsDirective.origin = origin;

      this.directionsDirective.destination = destination;

      if (this.directionsDirective.directionsDisplay === undefined) {
        this.mapsAPILoader.load().then(() => {
          this.directionsDirective.directionsDisplay = new google.maps.DirectionsRenderer();

          if (inputRef) {
            const autocompleteInput = new google.maps.places.Autocomplete(inputRef.nativeElement, {
              types: []
            });

            autocompleteInput.addListener('place_changed', () => {
              const place = autocompleteInput.getPlace();

              if (place.geometry === undefined)
                return;

              this.updatePath(place.geometry.location.lat(), place.geometry.location.lng());
            });
          }
        });
      }

      if (destination)
        this.directionsDirective.updateDirections();

    } else {

      throw new Error('GmapsHelpers error: GmapsDirectionsDirective undefined.')
    }
  }

  public updatePath(lat: number, lng: number, additionalText?: string): void {

    this.directionsDirective.destination = new GmapsPoint(
      parseFloat(lat.toString()),
      parseFloat(lng.toString())
    );

    this.directionsDirective.updateDirections(additionalText);
  }

  public changeTravelMode(mode: string): void {
    this.directionsDirective.travelMode = mode;
    this.directionsDirective.updateDirections();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/gmaps-helpers.model.ts